module.exports = __webpack_public_path__ + "img/icon-hero-ig.bee8993f.png";